export enum InputType{
  normal="normal",
  text="text",
  email="email",
  password="password",
  visiblePassword="visiblePassword",
  number=  "number",
  textarea=  "textarea",
}
